"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      clickSubmit: false,
      baseURL: this.config.BASE_URL,
      form: {
        status: 1
      }
    };
  },
  computed: {
    siteInfo: function siteInfo() {
      return this.$store.state.user.siteInfo;
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id > 0) this.getInfo();
  },
  methods: {
    /**
     * 获取信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('AlipayMini/getConfig', {
        app_id: this.$route.params.id
      }).then(function (res) {
        _this.form = {
          mine_agent_id: res.agent_id,
          app_name: res.app_name,
          app_id: res.appId,
          pid: res.pid,
          aes_key: res.aes_key,
          service_id: res.service_id,
          public_key: res.alipayrsaPublicKey,
          app_cert: res.app_cert,
          alipay_cert: res.alipay_cert,
          root_cert: res.root_cert,
          private_key: res.rsaPrivateKey,
          status: 1
        };
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var url = 'AlipayMini/saveConfig',
        params = JSON.parse(JSON.stringify(this.form));
      if (this.$route.params.id > 0) params.id = this.$route.params.id;
      this.clickSubmit = true;
      this.$post(url, params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        if (_this2.checkRoles(['terminal'])) {
          _this2.$router.push({
            path: '/ali/index'
          });
          return;
        }
        _this2.$router.push({
          path: '/setting/aliIndex'
        });
      }).catch(function (err) {
        _this2.clickSubmit = false;
      });
    }
  }
};